/**
 * @file Render the export fingerprint string ("🦊 🌙 4271") derived from the
 * `fingerprint_seed` shared via Firestore. Visually mirrors the mobile
 * `FingerprintDisplay` widget so the user can directly compare the two.
 */

import { useEffect, useState } from "react";
import { decodeBase64 } from "../lib/url";
import { deriveFingerprint } from "@/shared/fingerprint/deriver";

export function FingerprintCard({ seedB64 }: { seedB64: string }) {
  const [text, setText] = useState<string>("—");

  useEffect(() => {
    let active = true;
    void (async () => {
      try {
        const bytes = decodeBase64(seedB64);
        if (bytes.byteLength !== 16) {
          if (active) setText("—");
          return;
        }
        const out = await deriveFingerprint(bytes);
        if (active) setText(out);
      } catch {
        if (active) setText("—");
      }
    })();
    return () => {
      active = false;
    };
  }, [seedB64]);

  return (
    <div
      style={{
        display: "inline-flex",
        padding: "20px 28px",
        borderRadius: "16px",
        border: "1px solid var(--color-border)",
        background: "var(--color-surface)",
        fontSize: "32px",
        fontWeight: 600,
        letterSpacing: "0.25em",
        color: "var(--color-text)",
      }}
      aria-label={`fingerprint: ${text}`}
    >
      {text}
    </div>
  );
}
